<div class="paginator-container" [ngStyle]="{ 'justify-content': position }">
  <button mat-icon-button color="accent" [disabled]="pagination_clicked_count === 1" (click)="prevPage()">Last</button>
  <span class="paginator-label">Page {{ pagination_clicked_count }}</span>
  <button mat-icon-button color="accent" [disabled]="disable_next" (click)="nextPage()">Next</button>
</div>
